module.exports = __webpack_public_path__ + "ty8-9a28951e.png";